import { ReactElement } from 'react';

import DashboardVariantV2GiverContentInTransitTabProvider from './Context';

import {
  DashboardVariantV2GiverContentTabContainer,
  DashboardVariantV2GiverContentWrapper,
} from '../../styles';

import {
  DashboardVariantV2GiverContentInTransitTabActions,
  DashboardVariantV2GiverContentInTransitTabCurrentFilters,
  DashboardVariantV2GiverContentInTransitTabDataTable,
} from './Components';

const DashboardVariantV2GiverContentInTransitTab = (): ReactElement => (
  <DashboardVariantV2GiverContentInTransitTabProvider>
    <DashboardVariantV2GiverContentTabContainer>
      <DashboardVariantV2GiverContentInTransitTabActions />

      <DashboardVariantV2GiverContentInTransitTabCurrentFilters />

      <DashboardVariantV2GiverContentWrapper>
        <DashboardVariantV2GiverContentInTransitTabDataTable />
      </DashboardVariantV2GiverContentWrapper>
    </DashboardVariantV2GiverContentTabContainer>
  </DashboardVariantV2GiverContentInTransitTabProvider>
);

export default DashboardVariantV2GiverContentInTransitTab;
